import React, { useEffect } from 'react';
import { toast } from "react-toastify";

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import SuccessPage from './pages/Success';
import LandingPage from './pages/landing/LandingPage';
import Payment from "./pages/Payment";
import Success from "./pages/Success";
import Cancel from "./pages/Cancel";
import PaymentSuccess from "./pages/PaymentSuccess";
import ComingSoon from './components/ComingSoon';
import ProtectedRoute from './components/ProtectedRoute';
import PaymentProtectedRoute from './components/PaymentProtectedRoute';
import Diagnosis from './components/Diagnosis';
import ScrollToTop from './components/ScrollToTop';
// Route Components for other roles
import PatientRoutes from './routes/PatientRoutes';
import PsychiatristRoutes from './routes/PsychiatristRoutes';
import NurseRoutes from './routes/NurseRoutes';
import AdminRoutes from './routes/AdminRoutes';
import DoctorList from './pages/DoctorList';
import DoctorDetails from "./pages/DoctorDetails";
import NurseList from './pages/NurseList';
import NurseDetail from './pages/NurseDetail';
import MonthlyAssessment from './pages/MonthlyAssessment';
import MonthlyAssessmentSuccess from './pages/MonthlyAssessmentSuccess';
import MonthlyAssessmentResults from './pages/MonthlyAssessmentResults';
import ReschedulePaymentSuccess from './pages/ReschedulePaymentSuccess'
import CarePlan from './pages/CarePlan';
import AboutADHD from './pages/AboutADHD';
import Medications from './pages/Medications';
import Costs from './pages/Costs';
import AboutUs from './pages/AboutUs';
import OurNurses from './pages/OurNurses';
import Legal from './pages/Legal';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsofService from './pages/TermsofService';
import NurseProfile from './pages/NurseProfile';
import PublicNurseList from './pages/nurse/NurseList';
import NotFound from './components/NotFound';

// Token refresh manager - initializes automatically on import
import './services/tokenRefreshManager';
import './services/tokenDebugger';
import './App.css';
import CourseModule from './pages/course/CourseModule';
import CourseModuleAssement from './pages/course/CourseModuleAssement';
import SEOHeader from './components/SEOHeader';



function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/diagnosis" element={<Diagnosis />} />
          <Route path="/care-plan" element={<CarePlan />} />
          <Route path="/about-adhd" element={<AboutADHD />} />
          <Route path="/medications" element={<Medications />} />
          <Route path="/costs" element={<Costs />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/nurses" element={<OurNurses/>} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsofService />} />
          <Route path="/nurse/adhdcourse/:id" element={<CourseModule />} />
          <Route path="/nurse/assement/:id" element={<CourseModuleAssement />} />
          
          
          {/* Payment Protected Routes */}
          <Route path="/nurses/list" element={
            <PaymentProtectedRoute>
              <NurseList />
            </PaymentProtectedRoute>
          } />
          <Route path="/nurses/details/:id" element={
            // <PaymentProtectedRoute>
              <NurseDetail />
            // </PaymentProtectedRoute>
          } />



          <Route path="/nurse-profile/:id"  element={
              <PaymentProtectedRoute>
                <NurseProfile />
              </PaymentProtectedRoute>
          }/>


          <Route path="/doctors" element={<DoctorList />} />
          <Route path="/doctor/:id" element={<DoctorDetails />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/payment/success" element={<Success />} />
          <Route path="/payment/cancel" element={<Cancel />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/reschedule/payment/success" element={<ReschedulePaymentSuccess />} />
          <Route path="/monthly-assessment/:sessionId" element={<MonthlyAssessment />} />
          <Route path="/monthly-assessment-success" element={<MonthlyAssessmentSuccess />} />
          <Route path="/monthly-assessment-result/:sessionId" element={<MonthlyAssessmentResults />} />
          {/* Protected Routes */}
          <Route
            path="/*"
            element={
              <ProtectedRoute allowedRoles={["patient"]}>
                <PatientRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/psy/*"
            element={
              <ProtectedRoute allowedRoles={["psychiatrist"]}>
                <PsychiatristRoutes />
              </ProtectedRoute>
            }
          />

          <Route
            path="/nurse/*"
            element={
              <ProtectedRoute allowedRoles={["nurse"]}>
                <NurseRoutes />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/*"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminRoutes />
              </ProtectedRoute>
            }
          />

          {/* Logout Route */}
          <Route path="/logout" element={<Navigate to="/login" replace />} />

          {/* Catch-all route */}
          <Route
            path="*"
            element={
              <NotFound/>
            }
          />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
